import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import { makeStyles } from '@material-ui/core/styles';
import React, { useState, useEffect } from "react";
import "../index.css";

const useStyles = makeStyles((theme) => ({
	root: {
		color: 'black',
		padding: '0 10px',
		fontSize: 'large',
		fontWeight: 'bold',
		boxShadow: "none !important",
		textAlign: "center",
		wordBreak: 'break-all'
	},
	textBox: {
		padding: '1rem'
	},
	heading: {
		paddingBottom: '1rem !Important'
	},
	chatHeading: {
        textAlign: 'left',
        fontWeight: 'bold'
    },   
    chatSummary :{
        textAlign: 'left'
    },
}));

const ParagraphComponent = (props) => {
	const { responseData } = props;
	const classes = useStyles();
	return (
		<>
			{responseData?.map((item, index) => (
				<Box key={index} sx={{pt:1,pb:1,pl:2,pr:2}}>
					<Typography variant="subtitle1" className={classes.chatHeading}>
						{item.heading}
					</Typography>
					<Typography variant="body2" className={classes.chatSummary}>
						{item.summary}
					</Typography>
				</Box>
			))}
		</>
	);
};

export default ParagraphComponent;
